import React from 'react';
import styled from 'styled-components';
import IconBrandStdClickCollect from '@tvg/fuse-icons/lib/BrandClickCollect';
import IconLocalShipping from '@tvg/fuse-icons/lib/LocalShipping';
import { Icon, TypographyComponent as TypographyElement, Link, Divider } from '@tvg/fuse-design';
import { DeliveryCardProps } from '../DeliveryAndReturnsProps';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: var(--spacing-space24);
`;

const IconContainer = styled.div`
  flex: 0 0 var(--spacing-space32);
  position: relative;
  margin-right: var(--spacing-space8);
`;

const HeadingContainer = styled.div`
  display: flex;
  align-items: center;
`;

const TextContainer = styled.div<{ withLink: boolean }>`
  display: flex;
  flex: 1 1 0%;
  align-items: ${(props) => (props.withLink ? 'normal' : 'center')};
  flex-direction: ${(props) => (props.withLink ? 'column' : 'row')};

  strong {
    color: var(--color-global-grey1000);
  }

  p:last-child {
    margin-bottom: 0;
  }
`;
const DividerContainer = styled.div`
  margin-top: var(--spacing-space24);
`;

const CLICK_AND_COLLECT = 'Click and collect';

function DeliveryCard(props: DeliveryCardProps) {
  const { onClick, link, text, title } = props;

  return (
    <Container data-testid="delivery-card">
      <HeadingContainer>
        <IconContainer>
          <Icon
            icon={title === CLICK_AND_COLLECT ? <IconBrandStdClickCollect /> : <IconLocalShipping />}
            width="32px"
            height="32px"
            dataTestId="delivery-card-icon"
          />
        </IconContainer>
        <TypographyElement
          tag="h2"
          type="heading"
          size="1"
          data-testid="delivery-card-title"
          dangerouslySetInnerHTML={{
            __html: title,
          }}
        />
      </HeadingContainer>
      <TextContainer withLink={!!link}>
        <TypographyElement
          tag="p"
          type="paragraph"
          size="m1"
          data-testid="delivery-card-text"
          dangerouslySetInnerHTML={{
            __html: text,
          }}
        />

        {link && (
          <Link
            href="#"
            onClick={(event: MouseEvent) => {
              event.preventDefault();
              onClick();
            }}
            data-testid="delivery-card-link"
            size="medium"
            dangerouslySetInnerHTML={{
              __html: link,
            }}
          />
        )}
      </TextContainer>
      <DividerContainer>
        <Divider />
      </DividerContainer>
    </Container>
  );
}

export default DeliveryCard;
